import React from "react";
import PropTypes from "prop-types";

function Price({ value }) {
  const priceFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return <span>{priceFormatter.format(value)}</span>;
}

export default Price;

Price.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
